import React from "react";
import classes from "./FireMarker.module.css";

const FireMarker = () => {
	return (
		<div className={classes.container}>
			<img
				style={{
					width: 15
				}}
				src="/images/icons/fire.png"
				alt="marker"
			/>
		</div>
	);
};

export default FireMarker;
